/**
 * Token Manager
 * 
 * Security Standard 27 — Authentication Security:
 * - Sensitive authentication credentials (JWTs) must NEVER be stored in localStorage.
 * - Primary session authentication is handled securely via HttpOnly, Secure, SameSite cookies.
 * - When needed as an in-memory transport or bearer fallback for non-cookie calls,
 *   the token is held strictly in volatile JavaScript runtime memory (closure).
 * - It is NEVER exposed to persistent browser storage (localStorage / sessionStorage)
 *   where it could be harvested by XSS attacks.
 */

let inMemoryAccessToken: string | null = null;
let inMemoryRefreshToken: string | null = null;

export const tokenManager = {
  getAccessToken(): string | null {
    return inMemoryAccessToken;
  },

  setAccessToken(token: string | null): void {
    inMemoryAccessToken = token;
  },

  getRefreshToken(): string | null {
    return inMemoryRefreshToken;
  },

  setRefreshToken(token: string | null): void {
    inMemoryRefreshToken = token;
  },

  clearTokens(): void {
    inMemoryAccessToken = null;
    inMemoryRefreshToken = null;
    // Explicitly sanitize any legacy tokens from localStorage if they ever existed
    if (typeof window !== 'undefined' && window.localStorage) {
      window.localStorage.removeItem('auth_token');
      window.localStorage.removeItem('refresh_token');
      window.localStorage.removeItem('xservices_token');
      window.localStorage.removeItem('xservices_authenticated');
    }
  },

  hasValidToken(): boolean {
    return !!inMemoryAccessToken && inMemoryAccessToken.trim().length > 0;
  },
};
